import Vue from "vue";
import Vuex from "vuex";
import storage from "store";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    appLoading: false,
    authed: false,
    user: {},
    isOnNative: false,
    deviceInfo: {
      hasInfo: false
    },
    viewingScenarioId: "",
    showTutorial: false,
    hideTutorialPermanently: false
  },
  mutations: {
    initialiseStore(state) {
      if (storage.get("store")) {
        this.replaceState(
          Object.assign(state, JSON.parse(storage.get("store")))
        );
      }
    },
    setAppLoading(state, appLoading) {
      state.appLoading = appLoading;
    },
    setAuthed(state, authed) {
      state.authed = authed;
    },
    setChangedPassword(state, didChange) {
      if (didChange) {
        state.user.force_password_change = false;
      }
    },
    setUser(state, user) {
      state.user = user;
    },
    setDeviceInfo(state, deviceInfo) {
      state.deviceInfo = deviceInfo;
      if (state.deviceInfo.device_id && state.deviceInfo.product) {
        state.deviceInfo.hasInfo = true;
      } else {
        state.deviceInfo.hasInfo = false;
      }
    },
    setIsOnNative(state, isOnNative) {
      state.isOnNative = isOnNative;
    },
    setViewingScenarioId(state, viewingScenarioId) {
      state.viewingScenarioId = viewingScenarioId;
    },
    setShowTutorial(state, showTutorial) {
      state.showTutorial = showTutorial;
    },
    setHideTutorialPermanently(state, hidePermanently) {
      state.hideTutorialPermanently = hidePermanently;
    }
  },
  getters: {
    getAppLoading: state => {
      return state.appLoading;
    },
    getAuthed: state => {
      return state.authed;
    },
    getUser: state => {
      return state.user;
    },
    getDeviceInfo: state => {
      return state.deviceInfo;
    },
    getIsOnNative: state => {
      return state.isOnNative;
    },
    getViewingScenarioId: state => {
      return state.viewingScenarioId;
    },
    getShowTutorial: state => {
      return state.authed && state.showTutorial;
    },
    getHideTutorialPermanently: state => {
      return state.hideTutorialPermanently;
    }
  }
});
store.subscribe((mutation, state) => {
  storage.set("store", JSON.stringify(state));
});
